import React, { useState } from "react";
import StepBackButton from "../../../../components/common/StepBackButton/StepBackButton";
import {
  AdminPageTitle,
  AdminDetailFieldLabel,
  AdminMainText,
  AdminMetadataText,
  AdminHeaderAction,
  adminWizardInputClasses,
} from "../../../AdminDashboard/shared/adminUx";
import { POPUP_FORM_CONTENT_CLASS } from "../../../../components/popup/popupLayoutSpec";
import DropzoneUploader from "../../../../components/common/DropzoneUploader/DropzoneUploader";
import { runTextPipeline } from "../../../../utils/contentSafety";
import Alerts from "../../../../components/common/Alerts/Alerts";
import {
  BUSINESS_FORM_SECTION_GAP_CLASS,
  BUSINESS_FORM_ACTION_ROW_END_CLASS,
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
  BUSINESS_WIZARD_TITLE_CLASS,
} from "../../shared/businessLayoutSpec";

const Form = ({ secondMainHeading, secondP, closePopup }) => {
  const [step, setStep] = useState(1);
  const [completion, setCompletion] = useState(0);
  const [formData, setFormData] = useState({
    fullName: "",
    documentNumber: "",
    state: "",
    issueDay: "",
    issueMonth: "",
    issueYear: "",
    expiryDay: "",
    expiryMonth: "",
    expiryYear: ""
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleUploadComplete = (uploadData) => {
    const newImages = Array.isArray(uploadData) ? uploadData : [uploadData];
    const processedImages = newImages.map((data) => ({
      name: data.fileName,
      url: data.url,
    }));
    
    setUploadedFiles(prev => [...prev, ...processedImages]);
  };

  const deleteImage = (index) => {
    setUploadedFiles(prev => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      {step === 1 && (
        <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <div className={POPUP_FORM_CONTENT_CLASS}>
            <AdminPageTitle className={BUSINESS_WIZARD_TITLE_CLASS}>
              Certification details
            </AdminPageTitle>
            <div className={`${BUSINESS_FORM_SECTION_GAP_CLASS} w-full`}>
              <div className="mx-auto rounded-lg mb-[16px] overflow-y-auto hidden-scrollbar pb-5">
                <div className="space-y-1">
                  <AdminDetailFieldLabel htmlFor="cert-full-name">Full name</AdminDetailFieldLabel>
                  <input
                    id="cert-full-name"
                    type="text"
                    placeholder="Enter your full name"
                    className={adminWizardInputClasses(false)}
                    value={formData.fullName}
                    onChange={(e) => handleInputChange("fullName", e.target.value)}
                  />
                </div>
                <div className="mt-5 space-y-1">
                  <AdminDetailFieldLabel htmlFor="cert-doc-number">Document Number</AdminDetailFieldLabel>
                  <input
                    id="cert-doc-number"
                    type="text"
                    placeholder="Enter your document number"
                    className={adminWizardInputClasses(false)}
                    value={formData.documentNumber}
                    onChange={(e) => handleInputChange("documentNumber", e.target.value)}
                  />
                </div>
                <div className="mt-5 space-y-1">
                  <AdminDetailFieldLabel htmlFor="cert-state">State</AdminDetailFieldLabel>
                  <input
                    id="cert-state"
                    type="text"
                    placeholder="Enter your state"
                    className={adminWizardInputClasses(false)}
                    value={formData.state}
                    onChange={(e) => handleInputChange("state", e.target.value)}
                  />
                </div>
                <div className="mt-5">
                  <AdminDetailFieldLabel className="block mb-2">Issue date</AdminDetailFieldLabel>
                  <div className="flex w-full gap-4">
                    <div className="flex-[3]">
                      <input
                        type="text"
                        placeholder="DD"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.issueDay}
                        onChange={(e) => handleInputChange("issueDay", e.target.value)}
                        maxLength={2}
                      />
                    </div>
                    <div className="flex-[3]">
                      <input
                        type="text"
                        placeholder="MM"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.issueMonth}
                        onChange={(e) => handleInputChange("issueMonth", e.target.value)}
                        maxLength={2}
                      />
                    </div>
                    <div className="flex-[4]">
                      <input
                        type="text"
                        placeholder="YYYY"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.issueYear}
                        onChange={(e) => handleInputChange("issueYear", e.target.value)}
                        maxLength={4}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <AdminDetailFieldLabel className="block mb-2">Expiration date</AdminDetailFieldLabel>
                  <div className="flex w-full gap-4">
                    <div className="flex-[3]">
                      <input
                        type="text"
                        placeholder="DD"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.expiryDay}
                        onChange={(e) => handleInputChange("expiryDay", e.target.value)}
                        maxLength={2}
                      />
                    </div>
                    <div className="flex-[3]">
                      <input
                        type="text"
                        placeholder="MM"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.expiryMonth}
                        onChange={(e) => handleInputChange("expiryMonth", e.target.value)}
                        maxLength={2}
                      />
                    </div>
                    <div className="flex-[4]">
                      <input
                        type="text"
                        placeholder="YYYY"
                        className={`${adminWizardInputClasses(false)} w-full`}
                        value={formData.expiryYear}
                        onChange={(e) => handleInputChange("expiryYear", e.target.value)}
                        maxLength={4}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={BUSINESS_FORM_ACTION_ROW_END_CLASS}>
                <AdminHeaderAction
                  type="button"
                  onClick={() => {
                    const result = runTextPipeline((formData.fullName || "").trim(), "name");
                    if (!result.valid) {
                      Alerts.error(result.message);
                      return;
                    }
                    setStep(2);
                  }}
                >
                  Next
                </AdminHeaderAction>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <div className={POPUP_FORM_CONTENT_CLASS}>
            <AdminPageTitle className={BUSINESS_WIZARD_TITLE_CLASS}>
              Upload documents
            </AdminPageTitle>
            <div className={`${BUSINESS_FORM_SECTION_GAP_CLASS} w-full`}>
              <div className="mx-auto rounded-lg mb-[16px] overflow-y-auto hidden-scrollbar pb-5">
                {uploadedFiles.length > 0 && (
                  <div className="mb-5 w-full">
                    <div className="grid grid-cols-4 gap-3">
                      {uploadedFiles.map((fileObj, index) => (
                        <div key={index} className="relative group">
                          <div className="size-[60px]">
                            <div 
                              className="size-full bg-cover bg-center rounded-lg shadow-sm group-hover:shadow-md transition-all duration-200"
                              style={{ backgroundImage: `url(${fileObj.url})` }}
                            />
                            <button 
                              type="button" 
                              onClick={() => deleteImage(index)}
                              className="absolute -top-2 -right-2 size-5 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-gray-100 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            >
                              <i className="fi fi-rs-cross text-[10px] text-offblack"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <DropzoneUploader
                  isImage={true}
                  maxFiles={5}
                  loadingType="progress"
                  onUploadComplete={handleUploadComplete}
                  currentFileCount={uploadedFiles.length}
                  dashboardUpload
                />
              </div>

              <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
                <StepBackButton onClick={() => setStep(1)} />
                <AdminHeaderAction
                  type="button"
                  onClick={() => setStep(3)}
                  disabled={uploadedFiles.length === 0}
                >
                  Next
                </AdminHeaderAction>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === 3 && (
        <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <div className={POPUP_FORM_CONTENT_CLASS}>
            <AdminPageTitle className={BUSINESS_WIZARD_TITLE_CLASS}>
              Review & Submit
            </AdminPageTitle>
            <div className={`${BUSINESS_FORM_SECTION_GAP_CLASS} w-full`}>
              {/* Preview Information as text - Minimalist */}
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <AdminMetadataText className="text-mediumgray">Full name</AdminMetadataText>
                  <AdminMainText className="text-offblack">{formData.fullName || "-"}</AdminMainText>
                </div>
                <div className="flex justify-between items-center">
                  <AdminMetadataText className="text-mediumgray">Document Number</AdminMetadataText>
                  <AdminMainText className="text-offblack">{formData.documentNumber || "-"}</AdminMainText>
                </div>
                <div className="flex justify-between items-center">
                  <AdminMetadataText className="text-mediumgray">State</AdminMetadataText>
                  <AdminMainText className="text-offblack">{formData.state || "-"}</AdminMainText>
                </div>
                <div className="flex justify-between items-center">
                  <AdminMetadataText className="text-mediumgray">Issue date</AdminMetadataText>
                  <AdminMainText className="text-offblack">
                    {formData.issueDay && formData.issueMonth && formData.issueYear
                      ? `${formData.issueDay}/${formData.issueMonth}/${formData.issueYear}`
                      : "-"}
                  </AdminMainText>
                </div>
                <div className="flex justify-between items-center">
                  <AdminMetadataText className="text-mediumgray">Expiration date</AdminMetadataText>
                  <AdminMainText className="text-offblack">
                    {formData.expiryDay && formData.expiryMonth && formData.expiryYear
                      ? `${formData.expiryDay}/${formData.expiryMonth}/${formData.expiryYear}`
                      : "-"}
                  </AdminMainText>
                </div>
              </div>

              {/* Preview Images */}
              {uploadedFiles.length > 0 && (
                <div className="mt-5">
                  <div className="flex gap-2">
                    {uploadedFiles.map((fileObj, index) => (
                      <div key={index} className="relative">
                        <img 
                          src={fileObj.url} 
                          alt={fileObj.name}
                          className="w-16 h-16 object-cover rounded border border-mediumgray"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
                <StepBackButton onClick={() => setStep(2)} />
                <AdminHeaderAction
                  type="button"
                  onClick={() => {
                    setStep(4);
                    setTimeout(closePopup, 3000);
                  }}
                >
                  Submit
                </AdminHeaderAction>
              </div>
            </div>
          </div>
        </div>
      )}
      {step === 4 && (
        <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <div className={POPUP_FORM_CONTENT_CLASS}>
            <AdminPageTitle className={BUSINESS_WIZARD_TITLE_CLASS}>
              {secondMainHeading}
            </AdminPageTitle>
            <div className={`${BUSINESS_FORM_SECTION_GAP_CLASS} w-full`}>
              <div className="flex justify-center w-full">
                <div className="w-full mx-auto">
                  <AdminMainText className="text-offblack text-center block">
                    {secondP}
                  </AdminMainText>
                  <div className="flex justify-center mt-6">
                    <i className="fi fi-ss-badge-check text-[50px] text-primaryblue"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Form;
